<template>
  <div class="home-page">
    <!-- 导航栏 -->
    <NavBar />
    <div class="main-container">
      <!-- 主标题区 -->
      <section class="hero-banner">
        <div class="hero-content">
          <h1>AI.ZKWARE</h1>
          <div class="hero-subtitle">
            YOUR FIRST CRYPTO STRATEGY<br />
            POWERED BY AGENTIC AI
          </div>
          <div class="hero-actions">
            <button class="primary-btn" @click="goToVaults">Get Started</button>
            <button class="secondary-btn dark" v-if="false">Learn More</button>
          </div>
        </div>
      </section>

      <!-- 副标题区（放在main-container内） -->
      <section class="sub-hero">
        <h2>Agentic Crypto Trading</h2>
        <div class="sub-hero-img-placeholder">
          <img
            :src="require('@/assets/agentAi.webp')"
            alt="Agentic AI"
            class="sub-hero-img"
          />
        </div>
        <p class="sub-hero-desc">
          The next generation of automated<br />
          trading paradigm
        </p>
        <button class="secondary-btn dark" v-if="false">Read More</button>
      </section>

      <!-- Logo区（放在main-container内） -->
      <section class="logo-row">
        <img :src="logo4" alt="Logo4" class="logo-img" />
        <img :src="logo2" alt="Logo2" class="logo-img" />
        <img :src="logo3" alt="Logo3" class="logo-img" />
        <img :src="logo1" alt="Logo1" class="logo-img" />
      </section>
    </div>

    <!-- 三大卖点 -->
    <section class="features-section">
      <div class="features-inner">
        <!-- 第一行：左图右字 -->
        <div class="feature-row">
          <div class="feature-img">
            <img :src="easyImg" alt="Easy" class="feature-real-img" />
          </div>
          <div class="feature-info">
            <h3>Easy</h3>
            <p>3 step to deposit</p>
            <button class="feature-btn" v-if="false">Read More</button>
          </div>
        </div>
        <!-- 第二行：右图左字（reverse） -->
        <div class="feature-row reverse" style="flex-direction: row-reverse">
          <div class="feature-info">
            <h3>Fast</h3>
            <p>confirmed in 3 days</p>
            <button class="feature-btn" v-if="false">Read More</button>
          </div>
          <div class="feature-img">
            <img :src="fastImg" alt="Fast" class="feature-real-img" />
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ区 -->
    <section class="faq">
      <h2 class="faq-title">FAQ</h2>
      <div class="faq-list">
        <div class="faq-item" v-for="(item, idx) in faqList" :key="idx">
          <div class="faq-question-row" @click="toggleFaq(idx)">
            <span class="faq-toggle">{{ openedFaq === idx ? "−" : "+" }}</span>
            <span class="faq-question">{{ item.q }}</span>
          </div>
          <transition name="faq-fade">
            <div v-if="openedFaq === idx" class="faq-answer">
              {{ item.a }}
            </div>
          </transition>
        </div>
      </div>
    </section>

    <section class="get-started-section">
      <h2 class="get-started-title">Get Started today.</h2>
      <button class="get-started-btn" @click="goToVaults">Get Started</button>
    </section>

    <!-- 底部 -->
    <footer class="footer">
      <div class="footer-left">© Zkware Inc. 2025</div>
      <div class="footer-right">zkwarebd@gmail.com</div>
    </footer>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import NavBar from "@/components/NavBar.vue";
import logo1 from "@/assets/open_ai.png";
import logo2 from "@/assets/gemini.png";
import logo3 from "@/assets/claude.png";
import logo4 from "@/assets/deepseek.png";
import easyImg from "@/assets/easy.webp";
import fastImg from "@/assets/fast.png";
const router = useRouter();
function goToVaults() {
  router.push("/vaults");
}

const faqList = [
  {
    q: "What is Agentic Crypto Trading?",
    a: "Agentic AI holds out the promise of simplifying complex tasks such as crypto trading or managing digital assets by automating decisions, enhancing accessibility, and masking technical complexity.",
  },
  {
    q: "Is it easy to learn?",
    a: "Maximize your capital efficiency in one click: ai.zkware's smart vaults auto-apply battle-tested strategies with no coding required.",
  },
  // {
  //   q: "Do I need to code?",
  //   a: "ai.zkware delivers the most accessible vault solution — instantly access optimized yield performance through pre-configured strategies, requiring zero coding or implementation efforts.",
  // },
];

const openedFaq = ref(null);
function toggleFaq(idx) {
  openedFaq.value = openedFaq.value === idx ? null : idx;
}
</script>

<style scoped>
.home-page {
  font-family: "Inter", Arial, sans-serif;
  background: #f8fafc;
  color: #222;
  min-height: 100vh;
}
.main-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.hero-banner {
  width: 100%;
  max-width: 900px; /* 按原型调整 */
  min-height: 540px;
  background: #101522 url("@/assets/firstAi.jpg") center/cover no-repeat;
  /* border-radius: 24px; */
  margin: 48px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.hero-content {
  text-align: center;
  color: #fff;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 48px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.hero-content h1 {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 24px;
  letter-spacing: 2px;
}
.hero-subtitle {
  font-size: 1.4rem;
  color: #bfc6d1;
  margin-bottom: 32px;
  font-weight: 500;
  line-height: 1.5;
}
@media (max-width: 700px) {
  .hero-subtitle {
    font-size: 1rem;
    margin-bottom: 16px;
  }
}
.hero-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}
.primary-btn {
  background: #fff;
  color: #222;
  font-weight: 700;
  border: none;
  border-radius: 8px;
  padding: 12px 28px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.primary-btn:hover {
  background: #e2e8f0;
}
.secondary-btn.dark {
  background: #444;
  color: #fff;
  font-weight: 700;
  border: none;
  border-radius: 8px;
  padding: 12px 28px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.secondary-btn.dark:hover {
  background: #222;
}
.sub-hero {
  text-align: center;
  margin: 64px 0 32px 0;
}
.sub-hero h2 {
  font-size: 2.8rem;
  font-weight: 800;
  margin-bottom: 32px;
  color: #101522;
}
.sub-hero-img-placeholder {
  width: 100%;
  max-width: 600px;
  aspect-ratio: 2.1/1; /* 保持图片比例，或用 height: 320px; */
  margin: 0 auto 32px auto;
  background: #e2e8f0;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.sub-hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 24px; /* 可选，确保图片圆角 */
}
.sub-hero-desc {
  color: #888;
  font-size: 1.3rem;
  margin-bottom: 24px;
  margin-top: 0;
}
/* .logo-row {
  display: flex;
  justify-content: center;
  gap: 48px;
  margin: 56px 0 0 0;
} */
.logo-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-items: center;
  gap: 48px;
  margin: 56px 0 0 0;
}
.logo-img {
  width: 120px; /* 根据实际logo大小调整 */
  height: 120px;
  object-fit: contain;
  display: block;
  margin: 0 4px;
}
.logo-placeholder {
  display: flex;
  align-items: center;
  font-size: 2.2rem;
  color: #aaa;
  font-weight: 700;
  gap: 10px;
}
.features-section {
  background: #f5f5f5;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  padding: 64px 0;
  /* 让背景色横跨全屏 */
}
.features-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}
.feature-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 64px;
  max-width: 1000px;
  margin: 0 auto 56px auto;
}

.feature-img {
  width: 340px;
  height: 200px;
  border-radius: 32px;
  background: #f6f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  padding: 24px;
  overflow: hidden;
  position: relative;
}

.feature-real-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.feature-img-placeholder::after {
  content: "占位图";
  color: #bfc6d1;
  font-size: 1.5rem;
}
.feature-img-placeholder-green {
  background: #00ff70;
  color: #111;
  font-size: 2.5rem;
  font-weight: bold;
  position: relative;
}
.feature-img-placeholder-green::after {
  content: "fast.";
  color: #111;
  font-size: 2.5rem;
  font-weight: bold;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.feature-info {
  min-width: 220px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.feature-info h3 {
  font-size: 2.5rem;
  font-weight: 800;
  color: #101522;
  margin-bottom: 8px;
}
.feature-info p {
  color: #888;
  font-size: 1.2rem;
  margin-bottom: 24px;
}
.feature-btn {
  background: #222;
  color: #fff;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  padding: 10px 24px;
  font-size: 1rem;
  cursor: pointer;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  transition: background 0.2s;
}
.feature-btn:hover {
  background: #101522;
}
.faq {
  background: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  max-width: 1000px;
  margin: 24px auto 0 auto; /* 距离更紧凑 */
}

.faq-title {
  font-size: 2.8rem;
  font-weight: 800;
  color: #101522;
  margin-bottom: 32px;
  letter-spacing: 1px;
  text-align: center;
}

.faq-list {
  background: #ececec;
  border-radius: 24px;
  padding: 0;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
}
.faq-item {
  border-bottom: 1px solid #e5e7eb;
  padding: 0 0;
}
.faq-item:last-child {
  border-bottom: none;
}
.faq-question-row {
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  font-weight: 700;
  color: #101522;
  padding: 24px 32px;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;
}
.faq-question-row:hover {
  background: #f1f5f9;
}
.faq-toggle {
  font-size: 2rem;
  font-weight: 700;
  color: #888;
  margin-right: 18px;
  width: 28px;
  display: inline-block;
  text-align: center;
  transition: color 0.2s;
}
.faq-answer {
  text-align: left;
  color: #666;
  font-size: 1.1rem;
  font-weight: 400;
  padding: 0 32px 24px 60px;
  line-height: 1.7;
  background: none;
}
.faq-fade-enter-active,
.faq-fade-leave-active {
  transition: all 0.25s;
}
.faq-fade-enter-from,
.faq-fade-leave-to {
  opacity: 0;
  max-height: 0;
}
.faq-fade-enter-to,
.faq-fade-leave-from {
  opacity: 1;
  max-height: 200px;
}
.footer {
  background: #232323;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 48px 48px 32px 48px; /* 上下内边距加大 */
  min-height: 110px; /* 增加最小高度 */
  border-top: none;
  font-size: 1.05rem;
  box-sizing: border-box;
}

.footer-left {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.footer-right {
  font-weight: 500;
  letter-spacing: 0.5px;
  text-align: right;
}

.get-started-section {
  text-align: center;
  margin: 80px 0 40px 0;
}

.get-started-title {
  font-size: 3rem;
  font-weight: 800;
  color: #101522;
  margin-bottom: 36px;
  letter-spacing: 1px;
}

.get-started-btn {
  background: #222;
  color: #fff;
  font-weight: 700;
  border: none;
  border-radius: 12px;
  padding: 14px 36px;
  font-size: 1.15rem;
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  transition: background 0.2s, box-shadow 0.2s;
}
.get-started-btn:hover {
  background: #101522;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.18);
}
@media (max-width: 700px) {
  /* .navbar, */
  .footer {
    flex-direction: column;
    gap: 8px;
    padding: 32px 8vw 24px 8vw; /* 上下padding也加大 */
    font-size: 0.98rem;
    min-height: 90px;
  }
  .footer-right {
    text-align: center;
    width: 100%;
  }
  .features-section {
    padding: 32px 0;
  }
  .logo-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px 0;
  }
  .logo-img {
    width: 100px;
    height: 100px;
  }
  .faq {
    padding: 0;
    max-width: 100vw;
    margin: 24px 0 0 0;
  }
  .faq-title {
    font-size: 2.2rem;
    margin-bottom: 18px;
    text-align: center;
    font-weight: 800;
  }
  .faq-list {
    margin: 0 2vw; /* 更宽一点 */
    border-radius: 18px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    background: #ececec;
    padding: 0;
  }
  .faq-question-row {
    font-size: 1.05rem; /* 字体变小 */
    padding: 18px 18px; /* 左右内边距适当缩小 */
  }

  .hero-banner {
    width: 100vw;
    min-width: 100vw;
    max-width: 100vw;
    margin-left: 50%;
    margin-right: 0;
    margin-top: 0 !important;
    transform: translateX(-50%);
    /* border-radius: 0 0 24px 24px; */
    min-height: 420px;
    height: 80vw;
    box-sizing: border-box;
    padding: 0;
  }
  .hero-content {
    padding: 32px 0;
    max-width: 100vw;
  }
  .hero-content h1 {
    font-size: 2.5rem;
    margin-bottom: 16px;
  }
  .hero-subtitle {
    font-size: 1rem;
    margin-bottom: 12px;
  }
  .hero-actions {
    gap: 8px;
  }
  .primary-btn,
  .secondary-btn.dark {
    padding: 7px 14px;
    font-size: 0.85rem;
    border-radius: 7px;
  }

  .sub-hero {
    margin: 32px 0 16px 0;
    padding: 0 0;
  }
  .sub-hero h2 {
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 16px;
    line-height: 1.1;
    letter-spacing: 0;
  }
  .sub-hero-img-placeholder {
    width: 92vw;
    max-width: 100%;
    aspect-ratio: 2.1/1;
    height: auto;
    min-height: 120px;
    border-radius: 18px;
    margin-bottom: 16px;
  }
  .sub-hero-img {
    border-radius: 18px;
  }
  .sub-hero-desc {
    color: #b0b0b0;
    font-size: 1rem;
    margin-bottom: 12px;
    margin-top: 0;
    text-align: center;
    line-height: 1.4;
  }
  .sub-hero .secondary-btn.dark {
    font-size: 0.95rem;
    padding: 7px 18px;
    border-radius: 10px;
    margin-top: 8px;
    margin-bottom: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  .get-started-title {
    font-size: 1.8rem; /* 字体变小 */
    padding: 0 8vw; /* 两侧加内边距，防止贴边 */
    line-height: 1.18; /* 行高适当 */
    word-break: keep-all; /* 尽量不换行 */
    white-space: normal; /* 保持正常空格 */
  }
}

/* 桌面端：左右交错 */
@media (min-width: 901px) {
  .feature-row {
    flex-direction: row !important;
  }
}

/* 移动端：全部上下排列 */
@media (max-width: 900px) {
  .feature-row,
  .feature-row.reverse {
    flex-direction: column !important;
    gap: 32px;
    align-items: center;
    text-align: center;
  }
  .feature-img {
    order: 1;
  }
  .feature-info {
    order: 2;
    align-items: center !important;
    text-align: center !important;
  }
}
</style>
